module.exports = __webpack_public_path__ + "static/media/photographie.86c156a1.png";